module.exports = __webpack_public_path__ + "img/tmb-bank46x46.aa1fd022.jpg";